import { render, staticRenderFns } from "./last-updated.vue?vue&type=template&id=64cb42b3&scoped=true"
import script from "./last-updated.vue?vue&type=script&lang=js"
export * from "./last-updated.vue?vue&type=script&lang=js"
import style0 from "./last-updated.vue?vue&type=style&index=0&id=64cb42b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cb42b3",
  null
  
)

export default component.exports